module.exports = "/_next/static/images/chatu-7ddfef11d56fdd16d3795ef9ec9572b7.png";